import React, { useContext, useEffect, useState } from "react";
import { Container, Grid, Box, Typography, Paper } from "@mui/material";
import "bootstrap/dist/css/bootstrap.min.css";
import PersonIcon from "@mui/icons-material/Person";
import GroupIcon from "@mui/icons-material/Group";
import KingBedIcon from "@mui/icons-material/KingBed";

import HomeIcon from "@mui/icons-material/Home";
import PublicIcon from "@mui/icons-material/Public";
import CallIcon from "@mui/icons-material/Call";
import TagIcon from "@mui/icons-material/Tag";
import LocationOnIcon from "@mui/icons-material/LocationOn"; // Address
import ApartmentIcon from "@mui/icons-material/Apartment"; // District
import { apisPath } from "../../utils/path";
import { AuthContext } from "../../context/AuthContext";
import { CommonContext } from "../../context/CommonContext";
import { authHttp } from "../../services/commonHttpService";


const ProfileView = () => {
  const [profileData, setProfileData] = useState({});
  const { setIsLoading, setAlertState } = useContext(CommonContext);
  const { userId } = useContext(AuthContext);

  useEffect(() => {
    getProfileData();
  }, []);

  const getProfileData = async () => {
    setIsLoading(true);

    try {
      const response = await authHttp.get(`${apisPath?.userProfile}/${userId}`);

      if (response?.data?.status || response?.data?.data) {
        setProfileData(response?.data?.data);
      }
    } catch (error) {
      setAlertState({
        open: true,
        title: error?.response?.data?.message || "Failed to fetch patient details",
        btnTxt: "CLOSE",
        status: "fail",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container>
      {/* Page Title */}
      <Typography variant="h6" fontWeight={600} mb={3}>
        Facility Profile
      </Typography>

      {/* Training & Resources Section */}
      <Paper
        elevation={0}
        className="p-3 mb-4"
        style={{ borderRadius: 12, background: "#ffff" }}
      >
        <Typography variant="subtitle1" fontWeight={600} mb={2}>
          Training & Resources
        </Typography>

        <Grid container spacing={2}>
          {/* Doctors Trained */}
          <Grid item xs={12} md={3}>
            <Paper
              elevation={0}
              className="p-3"
              style={{ borderRadius: 12, background: "#F5F7FA" }}
            >
              <Box display="flex" alignItems="center" gap={2}>
                <Box className="p-2 rounded-3" sx={{ background: "#6B8CFF" }}>
                  <PersonIcon sx={{ color: "#fff" }} />
                </Box>
                <Box>
                  <Typography variant="body2" fontWeight={400} mb={0.5} className="custom-header">
                    Doctors Trained
                  </Typography>
                  <Typography fontWeight={700}>02</Typography>
                  <Typography variant="caption" className="custom-header">
                    No. of doctors trained for Cancer Care
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Grid>

          {/* Staff Nurses Trained */}
          <Grid item xs={12} md={3}>
            <Paper
              elevation={0}
              className="p-3"
              style={{ borderRadius: 12, background: "#F5F7FA" }}
            >
              <Box display="flex" alignItems="center" gap={2}>

                <Box className="p-2 rounded-3" sx={{ background: "#10B981" }}>
                  <GroupIcon sx={{ color: "#fff" }} />
                </Box>
                <Box>
                  <Typography variant="body2" fontWeight={400} mb={0.5} className="custom-header">
                    Staff Nurses Trained
                  </Typography>
                  <Typography fontWeight={700}>05</Typography>
                  <Typography variant="caption" className="custom-header">
                    No. of staff nurses trained for Cancer Care
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Grid>

          {/* Beds Sanctioned */}
          <Grid item xs={12} md={3}>
            <Paper
              elevation={0}
              className="p-3"
              style={{ borderRadius: 12, background: "#F5F7FA" }}
            >
              <Box display="flex" alignItems="center" gap={2}>
                <Box className="p-2 rounded-3" sx={{ background: "#F59E0B" }}>
                  <KingBedIcon sx={{ color: "#fff" }} />
                </Box>
                <Box>
                  <Typography variant="body2" fontWeight={400} mb={0.5} className="custom-header">
                    Beds Sanctioned
                  </Typography>
                  <Typography fontWeight={700}>15</Typography>
                  <Typography variant="caption" className="custom-header">
                    For Cancer Care Treatment
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Grid>

          {/* Beds Available */}
          {/* <Grid item xs={12} md={3}>
            <Paper
              elevation={0}
              className="p-3"
              style={{ borderRadius: 12, background: "#F5F7FA" }}
            >
              <Box display="flex" alignItems="center" gap={2}>
                <Box className="p-2 rounded-3" sx={{ background: "#8B5CF6" }}>
                  <KingBedIcon sx={{ color: "#fff" }} />
                </Box>
                <Box>
                  <Typography variant="body2" fontWeight={400} mb={0.5} className="custom-header">
                    Beds Available
                  </Typography>
                  <Typography fontWeight={700}>42</Typography>
                  <Typography variant="caption" className="custom-header">
                    For Cancer Care Treatment
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Grid> */}
        </Grid>
      </Paper>

      <Paper elevation={0} className="p-4" style={{ borderRadius: 12, background: "#ffff" }}>
        <Typography variant="subtitle1" fontWeight={600} mb={3}>
          Facility Information
        </Typography>

        <Grid container spacing={3}>

          {/* LEFT SIDE */}
          <Grid item xs={12} md={6}>

            {/* Facility Name */}
            <Typography variant="body2" fontWeight={600}>Facility Name</Typography>
            <Box display="flex" alignItems="center" gap={1} className="mb-3">
              <HomeIcon fontSize="small" className="text-muted" />
              <Typography className="text-muted">{profileData?.facility?.dccc_name}</Typography>
            </Box>

            {/* State Name */}
            <Typography variant="body2" fontWeight={600}>State Name</Typography>
            <Box display="flex" alignItems="center" gap={1} className="mb-3">
              <PublicIcon fontSize="small" className="text-muted" />
              <Typography className="text-muted">{profileData?.facility?.state?.state_name}</Typography>
            </Box>

            {/* Mobile No */}
            <Typography variant="body2" fontWeight={600}>Mobile No</Typography>
            <Box display="flex" alignItems="center" gap={1} className="mb-3">
              <CallIcon fontSize="small" className="text-muted" />
              <Typography className="text-muted">{profileData?.mobile ? profileData?.mobile : "-"}</Typography>
            </Box>

            {/* NIN ID */}
            <Typography variant="body2" fontWeight={600}>NIN ID</Typography>
            <Box display="flex" alignItems="center" gap={1} className="mb-3">
              <TagIcon fontSize="small" className="text-muted" />
              <Typography className="text-muted">{profileData?.facility?.nin ? profileData?.facility?.nin : "-"}</Typography>
            </Box>

          </Grid>

          {/* RIGHT SIDE */}
          <Grid item xs={12} md={6}>

            {/* Facility Address */}
            <Typography variant="body2" fontWeight={600}>Facility Address</Typography>
            <Box display="flex" alignItems="center" gap={1} className="mb-3">
              <LocationOnIcon fontSize="small" className="text-muted" />
              <Typography className="text-muted">{profileData?.facility?.address ? profileData?.facility?.address : "-"}</Typography>
            </Box>

            {/* District Name */}
            <Typography variant="body2" fontWeight={600}>District Name</Typography>
            <Box display="flex" alignItems="center" gap={1} className="mb-3">
              <ApartmentIcon fontSize="small" className="text-muted" />
              <Typography className="text-muted">{profileData?.facility?.district?.district_name ? profileData?.facility?.district?.district_name : "-"}</Typography>
            </Box>

            {/* HFR ID */}
            <Typography variant="body2" fontWeight={600} className="vihidden">HFR ID</Typography>
            <Box display="flex" alignItems="center" gap={1} className="vihidden">
              <TagIcon fontSize="small" className="text-muted" />
              <Typography className="text-muted">{profileData?.facility?.hfr_id ? profileData?.facility?.hfr_id : "-"}</Typography>
            </Box>
            <Typography variant="body2" fontWeight={600}>HFR ID</Typography>
            <Box display="flex" alignItems="center" gap={1}>
              <TagIcon fontSize="small" className="text-muted" />
              <Typography className="text-muted">{profileData?.facility?.hfr_id ? profileData?.facility?.hfr_id : "-"}</Typography>
            </Box>

          </Grid>

        </Grid>
      </Paper>
    </Container>
  );
}

export default ProfileView;